module.exports = __webpack_public_path__ + "img/nuvola_3.9112551f.png";